module.exports = __webpack_public_path__ + "media/src/components/Home/Benefit/affordable-premium-fadfd6fb707413245824e17892041b49.png";